import { api } from "@/api";

// 获取告警模版列表
export const getAlarmTemplateListAPi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/warnRuleTemplate/page",
    method: "POST",
    data: data,
  });
};
// 新增编辑告警模版
export const saveAlarmTemplateAPi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/warnRuleTemplate/save",
    method: "POST",
    data: data,
  });
};
// 删除编辑告警模版
export const delAlarmTemplateAPi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/warnRuleTemplate/delete",
    method: "POST",
    data: data,
  });
};

// 获取指标选项
export const getIndexSelectAPi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/dict/listSelectByName",
    method: "POST",
    data: data,
  });
};

// 获取告警规则列表
export const getAlarmRuleListAPi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/warnRule/page",
    method: "POST",
    data: data,
  });
};
// 新增编辑告警规则
export const saveAlarmRuleAPi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/warnRule/save",
    method: "POST",
    data: data,
  });
};
// 获取告警规则详情
export const getAlarmRuleDetailAPi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/warnRule/getDetailV2",
    method: "POST",
    data: data,
  });
};

// 删除编辑告警规则
export const delAlarmRuleAPi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/warnRule/delete",
    method: "POST",
    data: data,
  });
};

// 告警模版选项列表
export const getAlarmSelectListAPi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/warnRuleTemplate/listSelect",
    method: "POST",
    data: data,
  });
};

// 组织用户选项列表
export const getUserSelectListAPi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/member/listSelectByCurrentMember",
    method: "POST",
    data: data,
  });
};

// 获取告警列表
export const getAlarmListAPi2 = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/warnLog/page",
    method: "POST",
    data: data,
  });
};

// 结束告警规则
export const endAlarmAPi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/warnLog/over",
    method: "POST",
    data: data,
  });
};

// 发送验证码
export const sendCodeApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/validateCode/send",
    method: "POST",
    data: data,
  });
};
// 核验验证码
export const checkCodeApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/validateCode/checkValidateCode",
    method: "POST",
    data: data,
  });
};

// 获取产品选项
export const getProductSelectApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/product/listSelectV2",
    method: "POST",
    data: data,
  });
};

// 获取指标选项
export const getDictSelectApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/dict/listSelectByProductId",
    method: "POST",
    data: data,
  });
};
// 获取指标选项
export const getDictSelectApi2 = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/dict/listSelectByProductIdList",
    method: "POST",
    data: data,
  });
};

// 获取指标选项
export const listSelectByPrefixEquipmentIdApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/dict/listSelectByPrefixEquipmentId",
    method: "POST",
    data: data,
  });
};

// 设备离线-----------------------------------------------------
// 获取设备离线规则列表
export const getEquipmentOfflineRuleApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/equipmentOfflineRule/page",
    method: "POST",
    data: data,
  });
};
// 新增编辑设备离线规则列表
export const addEquipmentOfflineRuleApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/equipmentOfflineRule/save",
    method: "POST",
    data: data,
  });
};

// 获取设备离线规则列表详情
export const getEquipmentOfflineRuleDetailApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/equipmentOfflineRule/getDetail",
    method: "POST",
    data: data,
  });
};

// 删除设备离线规则列表
export const delEquipmentOfflineRuleApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/equipmentOfflineRule/delete",
    method: "POST",
    data: data,
  });
};

// 获取设备离线规则日志列表
export const getEquipmentOfflineLogApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/equipmentOfflineRuleLog/pageWithRule",
    method: "POST",
    data: data,
  });
};

// 获取设备离线记录列表
export const getEquipmentOfflineRecordApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/equipmentOfflineRuleLog/pageWithMember",
    method: "POST",
    data: data,
  });
};

// 获取离线规则可绑定的用户选项
export const getEquipmentOfflineMemberSelectApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/member/listSelect",
    method: "POST",
    data: data,
  });
};

// 消息--------------------------------------
// 获取消息数据
export const getNewMessageListApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/news/getData",
    method: "POST",
    data: data,
  });
};
// 分页获取消息数据
export const getPageMessageListApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/news/page",
    method: "POST",
    data: data,
  });
};
// 阅读单条消息
export const readOneMessageApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/news/read",
    method: "POST",
    data: data,
  });
};
// 阅读所有消息
export const readAllMessageApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/news/readAll",
    method: "POST",
    data: data,
  });
};

// 保存复合告警规则
export const saveCompoundWarnRuleApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/compoundWarnRule/save",
    method: "POST",
    data: data,
  });
};

export const getCompoundWarnRuleApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/compoundWarnRule/page",
    method: "POST",
    data: data,
  });
};

export const editCompoundWarnRuleApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/compoundWarnRule/getDetailV2",
    method: "POST",
    data: data,
  });
};
export const delCompoundWarnRuleApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/compoundWarnRule/delete",
    method: "POST",
    data: data,
  });
};

// 获取运算符列表
export const getOperatorList = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/enum/warnComparisonOperator",
    method: "GET",
    params: data,
  });
};

export const getCompoundWarnLogList = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/compoundWarnLog/page",
    method: "POST",
    data: data,
  });
};

export const overCompoundWarnLog = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/compoundWarnLog/over",
    method: "POST",
    data: data,
  });
};
export const switchFlagApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "zouk/rest/warnRule/update/switch",
    method: "POST",
    data: data,
  });
};
export const excludedApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/warnRule/excluded",
    method: "POST",
    data: data,
  });
};
export const warnRuleListApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/warnRule/rule/list",
    method: "POST",
    data: data,
  });
};
export const batchWarnApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/warnLog/over/batch",
    method: "POST",
    data: data,
  });
};
export const targetRuleListApi = (data) => {
  return api({
    headers: {
      memberId: window.localStorage.getItem("memberId"),
      Authorization: window.localStorage.getItem("Authorization"),
    },
    url: "/zouk/rest/warnRule/target/list",
    method: "POST",
    data: data,
  });
};
